/**
 * Loads an external polyfill via url where there is no browser support
 *
 * @param  {Boolean} test boolean indicating support for feature represented by the polyfill url
 * @param  {String} url url of polyfill script
 * @param  {Function} callback callback to run when script is loaded
 */
export default function(test, url, callback) {
  if (test === true) {
    return callback();
  }

  const script = document.createElement('script');
  script.src = url;
  script.onreadystatechange = callback;
  script.onload = callback;
  script.onerror = () => console.error('no polyfill found!');
  document.querySelector('head').appendChild(script);
}
